import {Store, useStore} from "vuex";
import {Ref, ref} from "vue";
import {AuswahlProdukt, Feature, FeaturedObject, SelectedFeature} from "@k/js/product"
import {globalsObject} from "@k/js/globalsObject"
import {SelectedFeatureFromProductGetter} from "@k/js/SelectedFeatureFromProductGetter"
import {
    createProduktPHPParameters,
    loadproduktPhpAndRegisterResource,
} from "@k/global/produktphpConnector"
import {EventVerteiler} from "@k/global/eventVerteiler"
import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import {ResourceInvalidationTriggers} from "@k/global/resourcemanager/resourceManager";
import {Produktwechsel} from "@km/components/productChange/Produktwechsel";
import {ProduktWechselDataInteractorMobile} from "@km/components/productChange/ProduktWechselDataInteractorMobile";
import {ProduktAuswahlProdukt} from "@km/store/ProduktAuswahlStore";

export function initProduktWechselMobile() {
    const store = useStore();
    Produktwechsel.init(new ProduktWechselDataInteractorMobile(store), (product:ProduktAuswahlProdukt)=>{
        store.dispatch("loadArtikelInfo", {product: product.Produkt, sport:product.websportUnterDemDasProduktGehostetIst}).then((reponse)=>{
                store.commit("SET_ARTIKEL_INFO", reponse);
                store.commit("OPEN_ARTIKELVIEW");
                store.commit("SET_OVERLAY_CLOSED", OverlayNames.produktlisteFeatures)
            }
        )
    })
}

// export class Produktwechsel {
//
//     public static productChosen = (store:Store<any>, productname: string) => {
//         const getters = store.getters;
//         const product = getters.getProductByProdukt(productname) ;
//         if(product.isArtikel && product.ArtikelWirdImIFrameDargestellt) {
//             // store.commit("STAGE_AUSWAHLPRODUKT", product);
//             store.dispatch("loadArtikelInfo", {product: product.Produkt, sport:product.websportUnterDemDasProduktGehostetIst}).then((reponse)=>{
//                 store.commit("SET_ARTIKEL_INFO", reponse);
//                 store.commit("OPEN_ARTIKELVIEW");
//                 store.commit("SET_OVERLAY_CLOSED", OverlayNames.produktlisteFeatures)
//             }
//             )
//             return;
//
//         }
//         if (getters.getChoosableFeatures(productname).length === 0) {
//             Produktwechsel.changeproductWithoutChoosableFeatures(store, productname)
//             return;
//         }
//
//         Produktwechsel.stageProductWithChoosableFeatures(store, productname, SelectedFeatureFromProductGetter.getSelectedFeatures(product, getters["ModelStore/getCurrentOwayoProduct"]));
//     }
//
//     public static stageProductWithChoosableFeatures(store:Store<any>, productname:string, selectedFeatures:SelectedFeature[]) {
//         const getters = store.getters;
//         const product = getters.getProductByProdukt(productname);
//
//         const data = createProduktPHPParameters(
//             product,
//             selectedFeatures,
//             getters["ModelStore/getWebsportFuerProduktAuswahlNormalized"],
//             getters["ModelStore/getLanguageIso"],
//             getters["ModelStore/getOwayoDirectLogin"]
//         );
//         loadproduktPhpAndRegisterResource(data, ".stage").then(response=>{
//             store.commit("STAGE_PRODUCT", {auswahlProdukt:product, features:selectedFeatures, data: response})
//             store.dispatch("loadProductPreviewPic")
//             currentlySelectedFeatures.value = SelectedFeatureFromProductGetter.getSelectedFeatures(product, getters.getStagedProduct).map(f=>f.name);
//         })
//         featuresZurAuswahl.value = getters.getChoosableFeatures(productname);
//         store.commit("SET_OVERLAY_OPEN", OverlayNames.produktlisteFeatures);
//     }
//
//     private static changeproductWithoutChoosableFeatures(store:Store<any>, productname:string) {
//
//         globalsObject.googleTracker.trackPageview("konfitrack-produktwechsel")
//         const product = store.getters.getProductByProdukt(productname);
//         const selectedFeatures = SelectedFeatureFromProductGetter.getSelectedFeatures(product, store.getters["ModelStore/getCurrentOwayoProduct"])
//         store.commit("SET_OVERLAY_CLOSED", OverlayNames.produktliste);
//         EventVerteiler.resourceManager.executeInvalidation(ResourceInvalidationTriggers.PRODUCTCHANGE);
//         globalsObject.productController.generateOwayoProduct(productname, selectedFeatures).then(() => {
//             if (store.getters.getStagedproductModel !== store.getters.getModel) {
//                 globalsObject.productController.loadOwayoProduct(product.Produkt);
//             } else {
//                 Produktwechsel.updateTitelTagWOProductChange(store);
//             }
//         })
//     }
//
//     static changeSelectedFeature(store:Store<any>, featuredObjectname: string, feature: Feature) {
//         globalsObject.googleTracker.trackPageview("featurewechsel.htm");
//         store.commit("SET_STAGED_SELECTED_FEATURE", {featuredObjectname, feature})
//         globalsObject.productController.generateOwayoProduct((store.getters.getStagedAuswahlProdukt as AuswahlProdukt).Produkt, store.getters.getStagedProductSelectedFeatures);
//     }
//
//     private static updateTitelTagWOProductChange(store:Store<any>) {
//         store.dispatch("useStagedProductAsCurrentProduct");
//         EventVerteiler.broadcast("updateTitelTagEvent", {
//             product: store.getters["ModelStore/getCurrentOwayoProduct"],
//             design: store.getters.getCurrentDesignname
//         });
//         EventVerteiler.broadcast("ProductChangedEvent");
//     }
//
//     static createProduct(store:Store<any>) {
//         // EventVerteiler.resourceManager.executeInvalidation(ResourceInvalidationTriggers.PRODUCTCHANGE);
//         globalsObject.googleTracker.trackPageview("konfitrack-produktwechsel")
//         globalsObject.productController.loadOwayoProduct(store.getters.getStagedProduct.produkt);
//         currentlySelectedFeatures.value = [];
//         featuresZurAuswahl.value=[];
//         store.commit("SET_OVERLAY_CLOSED", OverlayNames.produktliste);
//         store.commit("SET_OVERLAY_CLOSED", OverlayNames.produktlisteFeatures);
//     }
// }
